// extracted by mini-css-extract-plugin
export default {"status":"Status_status__AEp+h","active":"Status_active__0zSFQ","inactive":"Status_inactive__oj005","closed":"Status_closed__AxiEq","label":"Status_label__1llrq"};